/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
/**
 * <p>Represents different Report formats supported by this system<\/p>
 **/
export var ReportFormat;
(function (ReportFormat) {
    ReportFormat["EXCEL"] = "xlsx";
    ReportFormat["PLAIN_TEXT"] = "txt";
})(ReportFormat || (ReportFormat = {}));
